import {entityText} from "./EntityText";

const text={
    entityText
}

export default text;